import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <App /> {/* 🔹 Aquí NO debe haber otro <Router> */}
  </React.StrictMode>,
  document.getElementById("root")
);